import React, { memo, useState, useContext, useEffect } from "react";
import { IconButton, Grid } from "@mui/material";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  FormControlStyled,
  Row
} from "../styled/SidePanel.style";
import StyledDataSelect from "./StyledDataSelect";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import { getCountries } from "../../services/api/mapLocation.api";
import { LoadMapContext } from "../../pages/sections/web-map/LoadWebMap";
import { MapTools } from "../../constants/WebMap";
import MapDecoupleBtn from "./MapDecoupleBtn";

const SidePanelHead = ({
  isOpen,
  isCollapsed,
  handleCollapsed,
  setSelectedCountryPrems
}) => {
  const { mapPlacement, onChangeFocusedAdminLvl, appliedFilters } = useContext(WebMapContext);
  const { commonFilters, mapView, isMapsCoupled } = useContext(LoadMapContext);

  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countriesCodes, setCountriesCodes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("init");
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [allCountries, setAllCountries] = useState([]);
  const permissions = JSON.parse(localStorage.getItem("user"))?.permissions
  const permittedCountryCodes = permissions?.map((c) => c.country);
  const permittedCountries = allCountries?.filter(country => permittedCountryCodes?.includes(country.code))?.map((e) => e.label);

  useEffect(() => {
    if (countries.length === 0) getCountriesData();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      const countryIndex = countries.indexOf(selectedCountry);
      setSelectedCountryCode(countriesCodes[countryIndex]);
    } else {
      setSelectedCountryCode();
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (!selectedCountryCode) {
      setIsPanelOpen(false);
      isOpen(false);
    } else {
      setIsPanelOpen(true);
      isOpen(true);
    }
    if (mapPlacement === 'left') handleWebMapBasedOnFilters();
  }, [selectedCountryCode]);

  useEffect(() => {
    commonFilters.country && setIsPanelOpen(!isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    setIsPanelOpen(mapView === null ? isPanelOpen : true);
  }, [mapView]);

  const getCountriesData = async () => {
    try {
      const { data = [] } = await getCountries();
      const result = data.sort((a, b) => a?.label.localeCompare(b?.label));
      setAllCountries(result);
      setCountries(result.map((temp) => temp.label));
      setCountriesCodes(result.map((temp) => temp.code));
    } catch (err) {
      console.log("getCountriesData from getCountry Api Error: ", err);
    }
  };

  const handleWebMapBasedOnFilters = () => {
    onChangeFocusedAdminLvl({
      country:
        !selectedCountry || selectedCountry == "init" ? null : selectedCountry,
      countryCode: selectedCountryCode,
      level: null,
      levelVal: null,
      year: appliedFilters.year,
      quarter: appliedFilters.quarter,
      adminLevel1: null,
      adminLevel2: null,
      adminLevel3: null,
      geohash: null,
    });
  };

  return (
    <>
      {isCollapsed ? (
        <IconButton
          style={{ fontSize: "18px", margin: "2px 7px" }}
          onClick={() => {
            handleCollapsed(false);
            if (isPanelOpen) isOpen(true);
          }}
        >
          <GiHamburgerMenu
            aria-label="menu"
            style={{ fontSize: "20px", color: "#006F35", margin: "5px" }}
          />
        </IconButton>
      ) : isPanelOpen ? (
        <>
          <Grid
            container
            item
            style={{
              padding: "5px 15px",
              backgroundColor: "white",
            }}
          >
            <Row style={{
              justifyContent: mapPlacement === 'left' ? "space-between" : "flex-start",
              flexDirection: mapPlacement === 'left' ? "row" : "row-reverse"
            }}>
              <IconButton
                style={{ fontSize: "18px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCollapsed(true);
                  isOpen(false);
                }}
              >
                <GiHamburgerMenu
                  aria-label="menu"
                  style={{ fontSize: "20px", color: "#006F35", margin: "5px" }}
                />
              </IconButton>
              <FormControlStyled wd={mapPlacement === 'left' ? '100%' : 'auto'}>
                {mapPlacement === 'left' ? <StyledDataSelect
                  defaultVal={"Select the Country"}
                  options={countries.filter((c) => permittedCountries.includes(c))}
                  control={selectedCountry}
                  setControl={setSelectedCountry}
                  disabled={mapView === MapTools.SPLIT && !isMapsCoupled}
                  {...(mapView === MapTools.SPLIT && !isMapsCoupled && { enableCloseWhenDisabled: true })}
                />
                  : mapView === MapTools.SPLIT && <MapDecoupleBtn />}
              </FormControlStyled>
            </Row>
          </Grid>
        </>
      ) : (
        <Grid container item style={{ padding: "5px 15px " }}>
          <Row>
            <IconButton
              style={{ fontSize: "18px" }}
              onClick={() => handleCollapsed(true)}
            >
              <GiHamburgerMenu
                aria-label="menu"
                style={{ fontSize: "20px", color: "#006F35", margin: "5px" }}
              />
            </IconButton>
            <FormControlStyled>
              {mapPlacement !== 'right' &&
                <StyledDataSelect
                  defaultVal={"Select the Country "}
                  options={countries.filter((c) => permittedCountries.includes(c))}
                  control={selectedCountry}
                  setControl={setSelectedCountry}
                />}
            </FormControlStyled>
          </Row>
        </Grid>
      )}
    </>
  );
}

export default memo(SidePanelHead);
